// extracted by mini-css-extract-plugin
module.exports = {"section_title_container":"Title_section_title_container__kGfqY","section_title":"Title_section_title__3oqIJ","section_title_main":"Title_section_title_main__1M1sA"};